<script lang="ts">
  // BJL-CHECK: Collapsible (used) — the intermediate-stops list is a bjl Collapsible whose
  // `trigger` snippet is the "N stops · duration" summary line, so the component supplies the
  // aria-expanded/region wiring. See artifacts/deviations/PlanPage.md.
  import { Collapsible } from '@byjackli-labs/ui/Collapsible'
  import { Colors, getRouteColor } from '../../ui/colors'
  import { Type } from '../../ui/theme'
  import type { BusLeg, SubwayLeg } from '../../services/api'
  import { fmtDuration, fmtTime } from './format'
  import RideBadge from './RideBadge.svelte'
  import LiveDot from './LiveDot.svelte'

  interface Props {
    leg: SubwayLeg | BusLeg
  }

  const { leg }: Props = $props()

  let expanded = $state(false)
  const nStops = $derived(leg.stops.length - 1)
</script>

<div style="display: flex; gap: 10px;">
  <div style="display: flex; flex-direction: column; align-items: center; gap: 2px;">
    <RideBadge {leg} size={26} />
    <!-- getRouteColor falls back to the MTA bus blue for non-subway ids. -->
    <div
      style="width: 3px; flex: 1; border-radius: 2px; background-color: {getRouteColor(leg.routeId)}; min-height: 20px;"
    ></div>
  </div>
  <div style="flex: 1; min-width: 0; padding-bottom: 14px;">
    <div style="color: {Colors.text}; {Type.bodyLg}; font-weight: 700;">
      {leg.from.name}
      <span style="color: {Colors.textSecondary}; {Type.body}; margin-left: 8px;">
        {fmtTime(leg.departureTime)}
      </span>
      {#if leg.realtime}<span style="margin-left: 8px;"><LiveDot /></span>{/if}
    </div>
    <div style="color: {Colors.textSecondary}; {Type.body}; margin: 3px 0;">
      {leg.routeId}{leg.headsign ? ` toward ${leg.headsign}` : ''}
    </div>
    <Collapsible variant="ghost" size="sm" bind:open={expanded}>
      {#snippet trigger({ open })}
        <span style="color: {Colors.textMuted}; {Type.body};">
          {nStops} stop{nStops !== 1 ? 's' : ''} · {fmtDuration(leg.arrivalTime - leg.departureTime)}
          {open ? '▴' : '▾'}
        </span>
      {/snippet}
      {#snippet children()}
        <div style="display: flex; flex-direction: column; gap: 4px;">
          {#each leg.stops.slice(1, -1) as s (s.id)}
            <div style="color: {Colors.textMuted}; {Type.body};">
              {s.name} <span style="float: right;">{fmtTime(s.time)}</span>
            </div>
          {/each}
        </div>
      {/snippet}
    </Collapsible>
    <div style="color: {Colors.text}; {Type.bodyLg}; font-weight: 700; margin-top: 8px;">
      {leg.to.name}
      <span style="color: {Colors.textSecondary}; {Type.body}; margin-left: 8px;">
        {fmtTime(leg.arrivalTime)}
      </span>
    </div>
  </div>
</div>
